
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "74px",
    "height": "74px",
    "viewBox": "0 0 74 74",
    "enable-background": "new 0 0 74 74",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "74",
        "height": "74"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M134.824,313.062c1.51,0,2.734,1.224,2.734,2.733v4.375c0,1.509-1.225,2.733-2.734,2.733h-25.153\n\t\t\tc-1.51,0-2.733-1.225-2.733-2.733v-4.375c0-1.51,1.224-2.733,2.733-2.733h5.938c0.656,0,1.248,0.401,1.486,1.014\n\t\t\tc0.47,1.2,1.255,2.266,2.2,2.266h5.903c0.945,0,1.73-1.065,2.201-2.266c0.238-0.612,0.829-1.014,1.486-1.014H134.824z\n\t\t\t M110.343,311.967l3.672-9.155c0.153-0.384,0.308-0.688,0.837-0.688h3.022v-2.188h-3.344c-1.045,0-1.999,0.674-2.468,1.739\n\t\t\tl-4.956,11.298c0.68-0.619,1.575-1.007,2.564-1.007H110.343z M129.643,302.124c0.53,0,0.686,0.304,0.838,0.688l3.673,9.155h0.671\n\t\t\tc0.99,0,1.885,0.388,2.565,1.007l-4.958-11.298c-0.467-1.065-1.421-1.739-2.467-1.739h-3.343v2.188H129.643z M127.424,304.312\n\t\t\th-1.895v-6.563c0-1.208-0.98-2.187-2.188-2.187h-2.187c-1.208,0-2.188,0.979-2.188,2.187v6.563h-1.895\n\t\t\tc-1.121,0-1.777,1.117-1.137,1.924l4.887,6.17c0.691,0.872,2.158,0.874,2.851,0l4.886-6.17\n\t\t\tC129.201,305.429,128.545,304.312,127.424,304.312z"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "fill": "none",
            "d": "M73,65c0,4.4-3.6,8-8,8H9c-4.4,0-8-3.6-8-8V9c0-4.4,3.6-8,8-8h56c4.4,0,8,3.6,8,8V65z"
          }
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "polygon",
              "attrsMap": {
                "fill": "currentColor",
                "points": "34,43.532 33.48,51.63 38.455,41.891 \t\t"
              }
            },
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "currentColor",
                            "d": "M45.789,51.407c-0.141,0-0.278-0.038-0.399-0.115l-11.035-7.055c-0.176-0.112-0.298-0.293-0.335-0.5\n\t\t\t\t\t\tc-0.034-0.207,0.019-0.418,0.146-0.582l14.877-20.5c0.208-0.266,0.567-0.359,0.877-0.227c0.31,0.131,0.493,0.453,0.445,0.785\n\t\t\t\t\t\tl-3.842,27.555c-0.034,0.25-0.193,0.465-0.424,0.571C46.001,51.386,45.894,51.407,45.789,51.407z"
                          }
                        }
                      ]
                    },
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "currentColor",
                            "d": "M30.949,42.786c-0.111,0-0.226-0.027-0.332-0.078l-10.036-5.015c-0.253-0.126-0.413-0.386-0.41-0.669\n\t\t\t\t\t\tc0.001-0.283,0.163-0.541,0.417-0.664l28.718-13.917c0.325-0.157,0.718-0.058,0.929,0.235c0.211,0.295,0.179,0.698-0.076,0.955\n\t\t\t\t\t\tL31.479,42.565C31.336,42.71,31.145,42.786,30.949,42.786z"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  